import { TSelectOptions } from '@/components/Select';
import { ReceiptExemptionReasonEnum } from '@/services/types/TransactionData';
import { getHumanReadableReceiptExemption } from '../utils/getHumanReadableReceiptExemption';

export const receiptReasonSelectInputOptions: TSelectOptions[] = [
  {
    label: getHumanReadableReceiptExemption(ReceiptExemptionReasonEnum.NoReceiptGiven),
    value: ReceiptExemptionReasonEnum.NoReceiptGiven
  },
  {
    label: getHumanReadableReceiptExemption(ReceiptExemptionReasonEnum.LostReceipt),
    value: ReceiptExemptionReasonEnum.LostReceipt
  },
  {
    label: getHumanReadableReceiptExemption(ReceiptExemptionReasonEnum.DamagedOrFadedReceipt),
    value: ReceiptExemptionReasonEnum.DamagedOrFadedReceipt
  }
];
